<div class="card">
  <div [ngClass]="{'cards': accounts.length > 3}">
    <!-- Agregar el imagenId de la card -->
    <flame-list-card>
      <flame-list-card-item *ngFor="let account of accounts; index as i" 
        [type]="idItemCard === account?.card?.cardNumber ? 'select' : 'navigation'" 
        [select]="idItemCard === account?.card?.cardNumber"  
        (click)="selectAccount(account)"
        class="item"
      >
        <flame-card 
          id="card-item-{{i}}" 
          size="s" 
          [imageId]="account?.imageCode ?? '12345678900'" 
          orientation="vertical" 
          fallbackSrc 
        />
        <p class="card__name">{{ account?.account?.product?.productName }}</p>
        <p class="card__balance">${{ account?.account?.balance?.amount?.amount}} <span>MXN</span></p>
        <p class="card__cta">{{ buildDetailAccount(account) }}</p>
      </flame-list-card-item>
    </flame-list-card>
  </div>
</div>
